<script setup>
import { onMounted, provide, watch, ref, computed } from 'vue'
import { useRoute } from 'vue-router'
import TvbLayout from './layout/index.vue'
import { useWindowSize } from '@vueuse/core'
import { TvbConfig } from '@tvb-sz/tvb-headerfooter-frontend'
import '@tvb-sz/tvb-headerfooter-frontend/theme-default/index.css'
import { version as appVersion } from '../package.json'
import { useAppStore } from './stores/app'
defineOptions({ name: 'TvbApp' })

const app = useAppStore()
const { width, height } = useWindowSize()
const size = ref(import.meta.env.SSR ? 'xl' : null)
const env = import.meta.env.VITE_ENV
const setWindowSize = () => {
  if (import.meta.env.SSR) {
    return
  }
  document.getElementById('tvb').style.setProperty('--window-width', `${width.value}px`)
  document.getElementById('tvb').style.setProperty('--window-height', `${height.value}px`)
  document
    .getElementById('tvb')
    .style.setProperty(
      '--header-height',
      `${document.querySelector('#tvb > .tvb-container .tvb-header')?.clientHeight || 0}px`
    )
  document
    .getElementById('tvb')
    .style.setProperty(
      '--footer-height',
      `${document.querySelector('#tvb > .tvb-container .tvb-footer')?.clientHeight || 0}px`
    )

  const sizeMap = {
    xl: [Infinity, 1441],
    l: [1440, 1025],
    m: [1024, 769],
    s: [768, 391],
    xs: [390, -Infinity]
  }
  for (const key in sizeMap) {
    const [max, min] = sizeMap[key]
    if (max >= width.value && width.value >= min) {
      size.value = key
      break
    }
  }
}

const SSR_WIDTH = ref(1920)
const SSR_HEIGHT = ref(1080)

const route = useRoute()
provide('width', import.meta.env.SSR ? SSR_WIDTH : width)
provide('height', import.meta.env.SSR ? SSR_HEIGHT : height)
provide('setWindowSize', setWindowSize)
provide('size', size)

const roomqCallback = (state, url) => {
  window.console.log('roomqCallback', state, url)
  switch (state) {
    // -3
    case window.RoomQ.serving:
      break
    // -4
    case window.RoomQ.in_queue:
      break
    // 0
    case window.RoomQ.serverError:
      break
  }

  return true
}

const roomId = import.meta.env.VITE_ROOMQ_ID
const cookieDomain = import.meta.env.VITE_COOKIE_DOMAIN
const NOQ_SRC = `https://scripts.noq.com.hk/v2.0.8/noq-vwr.min.js?c=${roomId}&callback=roomqCallback&cookie_key=noq-cf-${roomId}-token&cookie_domain=${cookieDomain}&noq_r=false&noq_v=false`
const initVoteQueue = () => {
  if (app.config.vote_queue !== 1) {
    return
  }
  if (window?.RoomQ) {
    window.console.log('Roomq ticket checking...')
    window.RoomQ.checkTicket()
    return
  }
  window.console.log('Loading roomq script...')
  window.roomqCallback = roomqCallback
  const script = document.createElement('script')
  script.setAttribute('type', 'text/javascript')
  script.setAttribute('src', NOQ_SRC)
  document.getElementsByTagName('head')[0].appendChild(script)
}
watch(
  () => route.name + route.fullPath,
  () => {
    initVoteQueue()
  }
)

onMounted(() => {
  setWindowSize()
  setTimeout(setWindowSize, 300)
})

watch([width, height], () => setWindowSize())

const ssrHeaders = computed(() =>
  import.meta.env.SSR
    ? {
        'X-App-Client': `tvb-web/zh-HK/${appVersion}/12345678-1234-5678-1234-123456789abc`,

        'X-Ssr-Header': globalThis?.ssrHeaders || '',

        'X-Ssr-Render-Id': globalThis?.renderId || ''
      }
    : {}
)
</script>

<template>
  <tvb-config :env="env" :ssr-headers="ssrHeaders">
    <tvb-layout>
      <router-view />
    </tvb-layout>
  </tvb-config>
</template>

<style lang="scss">
.tvb-main {
  min-height: calc(100vh - 215px - 64px);
}

.tvb-mobile-sub-menu-container.show {
  z-index: 999;
}
</style>
